import { Placement } from '@noths/polaris-client-ribbons-design-system';

import { ReduxApplicationState } from '../combinedReducer';

export const selectPlacementProducts = (state: ReduxApplicationState, placement: Placement) =>
  state.richRelevance[placement].products;
